// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: #1e1e1e;
}

.browser-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #2d2d2d;
  border-bottom: 1px solid #404040;
  min-height: 36px;
}
.browser-toolbar button[mat-icon-button] {
  width: 28px;
  height: 28px;
  padding: 0;
  flex-shrink: 0;
}
.browser-toolbar button[mat-icon-button] ::ng-deep .mat-mdc-button-persistent-ripple,
.browser-toolbar button[mat-icon-button] ::ng-deep .mat-mdc-button-touch-target {
  width: 28px;
  height: 28px;
}
.browser-toolbar button[mat-icon-button] ::ng-deep .mdc-icon-button__icon,
.browser-toolbar button[mat-icon-button] ::ng-deep .mat-mdc-button-persistent-ripple {
  display: flex;
  align-items: center;
  justify-content: center;
}
.browser-toolbar button[mat-icon-button] mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: #b0b0b0;
  vertical-align: middle;
}
.browser-toolbar button[mat-icon-button]:hover mat-icon {
  color: #e0e0e0;
}
.browser-toolbar .url-bar {
  flex: 1;
  display: flex;
  align-items: center;
  background: #1e1e1e;
  border: 1px solid #404040;
  border-radius: 16px;
  padding: 0 10px;
  height: 28px;
}
.browser-toolbar .url-bar .url-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  margin-right: 6px;
  color: #808080;
}
.browser-toolbar .url-bar .url-icon.connected {
  color: #4caf50;
}
.browser-toolbar .url-bar input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: #d0d0d0;
  font-size: 13px;
  font-family: inherit;
}
.browser-toolbar .status-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
}
.browser-toolbar .status-indicator .status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #4caf50;
  animation: pulse 2s infinite;
}

.tab-bar {
  display: flex;
  background: #252525;
  border-bottom: 1px solid #404040;
  min-height: 30px;
  overflow-x: auto;
  scrollbar-width: none;
}
.tab-bar::-webkit-scrollbar {
  display: none;
}
.tab-bar .tab-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  min-width: 0;
  max-width: 200px;
  height: 30px;
  cursor: pointer;
  border-right: 1px solid #333;
  background: #1e1e1e;
  color: #808080;
  font-size: 12px;
  white-space: nowrap;
  transition: background 0.15s;
}
.tab-bar .tab-item.active {
  background: #2d2d2d;
  color: #d0d0d0;
  border-bottom: 2px solid #4caf50;
}
.tab-bar .tab-item:hover:not(.active) {
  background: #2a2a2a;
  color: #b0b0b0;
}
.tab-bar .tab-item.cdk-drag-preview {
  background: #2d2d2d;
  color: #d0d0d0;
  border: 1px solid #4caf50;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}
.tab-bar .tab-item.cdk-drag-placeholder {
  opacity: 0.3;
}
.tab-bar .tab-item .tab-title {
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}
.tab-bar .tab-item .tab-close {
  font-size: 14px;
  width: 14px;
  height: 14px;
  line-height: 14px;
  opacity: 0;
  transition: opacity 0.15s;
  flex-shrink: 0;
}
.tab-bar .tab-item .tab-close:hover {
  color: #f44336;
}
.tab-bar .tab-item:hover .tab-close {
  opacity: 1;
}
.tab-bar .cdk-drag-animating {
  transition: transform 200ms ease;
}
.tab-bar .tab-new {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  min-width: 28px;
  height: 30px;
  cursor: pointer;
  color: #808080;
  transition: color 0.15s, background 0.15s;
}
.tab-bar .tab-new mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}
.tab-bar .tab-new:hover {
  color: #d0d0d0;
  background: #2a2a2a;
}

.viewport-container {
  flex: 1;
  position: relative;
  overflow: hidden;
  outline: none;
  cursor: default;
}
.viewport-container .viewport-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
  image-rendering: auto;
  -webkit-user-select: none;
          user-select: none;
}
.viewport-container .loading-overlay,
.viewport-container .error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #b0b0b0;
}
.viewport-container .error-overlay {
  color: #f44336;
}
.viewport-container .error-overlay mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.viewport-container .setup-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #b0b0b0;
  padding: 24px;
  text-align: center;
}
.viewport-container .setup-overlay .setup-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #ff9800;
}
.viewport-container .setup-overlay h3 {
  margin: 0;
  color: #e0e0e0;
  font-size: 16px;
}
.viewport-container .setup-overlay p {
  margin: 0;
  font-size: 13px;
  max-width: 400px;
}
.viewport-container .setup-overlay .setup-instructions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 8px 0;
  background: #1a1a1a;
  border: 1px solid #404040;
  border-radius: 6px;
  padding: 8px 12px;
}
.viewport-container .setup-overlay .setup-instructions code {
  font-family: "JetBrains Mono", "Fira Code", monospace;
  font-size: 13px;
  color: #4caf50;
  -webkit-user-select: all;
          user-select: all;
}
.viewport-container .setup-overlay .setup-instructions .copy-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: #808080;
  transition: color 0.15s;
}
.viewport-container .setup-overlay .setup-instructions .copy-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.viewport-container .setup-overlay .setup-instructions .copy-btn:hover {
  color: #e0e0e0;
}
.viewport-container .setup-overlay .setup-hint {
  color: #808080;
  font-size: 12px;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/browser-widget/browser-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AACJ;AACI;;EAEE,WAAA;EACA,YAAA;AACN;AAEI;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;AAAN;AAGI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AADN;AAII;EACE,cAAA;AAFN;AAME;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAJJ;AAMI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAJN;AAMM;EACE,cAAA;AAJR;AAQI;EACE,OAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AANN;AAUE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AARJ;AAUI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;AARN;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAXF;AAYE;EAAuB,aAAA;AATzB;AAWE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;AATJ;AAWI;EACE,mBAAA;EACA,cAAA;EACA,gCAAA;AATN;AAYI;EACE,mBAAA;EACA,cAAA;AAVN;AAaI;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AAXN;AAcI;EACE,YAAA;AAZN;AAeI;EACE,gBAAA;EACA,uBAAA;EACA,OAAA;EACA,YAAA;AAbN;AAgBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,yBAAA;EACA,cAAA;AAdN;AAgBM;EACE,cAAA;AAdR;AAkBI;EACE,UAAA;AAhBN;AAoBE;EACE,gCAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,yCAAA;AAnBJ;AAqBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAnBN;AAsBI;EACE,cAAA;EACA,mBAAA;AApBN;;AAyBA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AAtBF;AAwBE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;AAtBJ;AAyBE;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAvBJ;AA0BE;EACE,cAAA;AAxBJ;AA0BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxBN;AA4BE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AA1BJ;AA4BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA1BN;AA6BI;EACE,SAAA;EACA,cAAA;EACA,eAAA;AA3BN;AA8BI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AA5BN;AA+BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AA7BN;AA+BM;EACE,qDAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;UAAA,gBAAA;AA7BR;AAgCM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;AA9BR;AAgCQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9BV;AAiCQ;EACE,cAAA;AA/BV;AAoCI;EACE,cAAA;EACA,eAAA;AAlCN;;AAuCA;EACE;IAAW,UAAA;EAnCX;EAoCA;IAAM,YAAA;EAjCN;AACF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background: #1e1e1e;\n}\n\n.browser-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: #2d2d2d;\n  border-bottom: 1px solid #404040;\n  min-height: 36px;\n\n  button[mat-icon-button] {\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    flex-shrink: 0;\n\n    ::ng-deep .mat-mdc-button-persistent-ripple,\n    ::ng-deep .mat-mdc-button-touch-target {\n      width: 28px;\n      height: 28px;\n    }\n\n    ::ng-deep .mdc-icon-button__icon,\n    ::ng-deep .mat-mdc-button-persistent-ripple {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      line-height: 18px;\n      color: #b0b0b0;\n      vertical-align: middle;\n    }\n\n    &:hover mat-icon {\n      color: #e0e0e0;\n    }\n  }\n\n  .url-bar {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    background: #1e1e1e;\n    border: 1px solid #404040;\n    border-radius: 16px;\n    padding: 0 10px;\n    height: 28px;\n\n    .url-icon {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n      margin-right: 6px;\n      color: #808080;\n\n      &.connected {\n        color: #4caf50;\n      }\n    }\n\n    input {\n      flex: 1;\n      background: none;\n      border: none;\n      outline: none;\n      color: #d0d0d0;\n      font-size: 13px;\n      font-family: inherit;\n    }\n  }\n\n  .status-indicator {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 0 8px;\n\n    .status-dot {\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background: #4caf50;\n      animation: pulse 2s infinite;\n    }\n\n  }\n}\n\n.tab-bar {\n  display: flex;\n  background: #252525;\n  border-bottom: 1px solid #404040;\n  min-height: 30px;\n  overflow-x: auto;\n  scrollbar-width: none;\n  &::-webkit-scrollbar { display: none; }\n\n  .tab-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 0 10px;\n    min-width: 0;\n    max-width: 200px;\n    height: 30px;\n    cursor: pointer;\n    border-right: 1px solid #333;\n    background: #1e1e1e;\n    color: #808080;\n    font-size: 12px;\n    white-space: nowrap;\n    transition: background 0.15s;\n\n    &.active {\n      background: #2d2d2d;\n      color: #d0d0d0;\n      border-bottom: 2px solid #4caf50;\n    }\n\n    &:hover:not(.active) {\n      background: #2a2a2a;\n      color: #b0b0b0;\n    }\n\n    &.cdk-drag-preview {\n      background: #2d2d2d;\n      color: #d0d0d0;\n      border: 1px solid #4caf50;\n      border-radius: 4px;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n    }\n\n    &.cdk-drag-placeholder {\n      opacity: 0.3;\n    }\n\n    .tab-title {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .tab-close {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n      line-height: 14px;\n      opacity: 0;\n      transition: opacity 0.15s;\n      flex-shrink: 0;\n\n      &:hover {\n        color: #f44336;\n      }\n    }\n\n    &:hover .tab-close {\n      opacity: 1;\n    }\n  }\n\n  .cdk-drag-animating {\n    transition: transform 200ms ease;\n  }\n\n  .tab-new {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    min-width: 28px;\n    height: 30px;\n    cursor: pointer;\n    color: #808080;\n    transition: color 0.15s, background 0.15s;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      line-height: 16px;\n    }\n\n    &:hover {\n      color: #d0d0d0;\n      background: #2a2a2a;\n    }\n  }\n}\n\n.viewport-container {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  outline: none;\n  cursor: default;\n\n  .viewport-image {\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n    image-rendering: auto;\n    user-select: none;\n  }\n\n  .loading-overlay,\n  .error-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    color: #b0b0b0;\n  }\n\n  .error-overlay {\n    color: #f44336;\n\n    mat-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n    }\n  }\n\n  .setup-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    color: #b0b0b0;\n    padding: 24px;\n    text-align: center;\n\n    .setup-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n      color: #ff9800;\n    }\n\n    h3 {\n      margin: 0;\n      color: #e0e0e0;\n      font-size: 16px;\n    }\n\n    p {\n      margin: 0;\n      font-size: 13px;\n      max-width: 400px;\n    }\n\n    .setup-instructions {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      margin: 8px 0;\n      background: #1a1a1a;\n      border: 1px solid #404040;\n      border-radius: 6px;\n      padding: 8px 12px;\n\n      code {\n        font-family: 'JetBrains Mono', 'Fira Code', monospace;\n        font-size: 13px;\n        color: #4caf50;\n        user-select: all;\n      }\n\n      .copy-btn {\n        background: none;\n        border: none;\n        cursor: pointer;\n        padding: 2px;\n        color: #808080;\n        transition: color 0.15s;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n\n        &:hover {\n          color: #e0e0e0;\n        }\n      }\n    }\n\n    .setup-hint {\n      color: #808080;\n      font-size: 12px;\n    }\n  }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
